<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
  <div class="tokens flex flex-col items-center">
    <div class="text-2xl font-bold uppercase">coming soon</div>
  </div>
</template>

<script>
export default {
  name: "TokensView"
};
</script>

<style scoped>

</style>